import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import EventListener from 'fbjs/lib/EventListener';
import lodashThrottle from 'lodash/throttle';
import domHelperWidth from 'dom-helpers/query/width';
import domHelperHeight from 'dom-helpers/query/height';
import domHelperStyle from 'dom-helpers/style';
import domHelperContains from 'dom-helpers/query/contains';
import videojs from 'video.js/dist/video.js';
import 'video.js/dist/video-js.css';
import ismobilejs from 'ismobilejs';

import Gallery from './Gallery';

import backgroundImg from '../images/HeartWriter-background.jpg';
import image1 from '../images/HeartWriter-1.jpg';
import image2 from '../images/HeartWriter-2.jpg';
import image3 from '../images/HeartWriter-3.jpg';
// import image4 from '../images/HeartWriter-4.jpg';
import image5 from '../images/HeartWriter-5.jpg';
import mp4Video from '../videos/HeartWriter-video.mp4';
import webmVideo from '../videos/HeartWriter-video.webm';

import '../styles/HeartWriter.css';

class HeartWriter extends React.Component {

  static contextTypes = {
    openModal: PropTypes.func
  };

  state = {
    showPopover: false
  };

  render() {
    return (
      <div className={classnames('HeartWriter', this.props.className)}>
        <div
          ref="videoWrapperNode"
          className="HeartWriter-videoWrapper">
          {
            ismobilejs.any ? (
              <div
                className="HeartWriter-mobileVideoBackground"
                src={backgroundImg}
              />
            ) : (
              <video
                ref="videoNode"
                id="HeartWriter-video"
                className="HeartWriter-video video-js"
                autoPlay
                loop
                width="100%"
                height="100%"
                poster={backgroundImg}
                data-setup='{
                }'>
                <source
                  src={mp4Video}
                  type="video/mp4"
                />
                <source
                  src={webmVideo}
                  type="video/webm"
                />
              </video>
            )
          }
        </div>
        <div className="HeartWriter-content">
          <h2 className="HeartWriter-title">
            {`HEART WRITER`}
          </h2>
          <h3 className="HeartWriter-subtitle">
            {'The Fastest Way To Type On iPad'}
          </h3>
          <p className="HeartWriter-description">
            {'Heart Writer is an iPad text editor with more than 40 desktop-level keyboard shortcuts and 90 additional function keys. The app was awarded first place in the Berkeley iOS competition at Apple HQ, Cupertino. The app has been ranked #5~#30 in Top Productivity Paid Chart in Japan, Europe, and US AppStores, and received 4~4.5 / 5 stars from many app review companies and users.'}
          </p>
          <p className="HeartWriter-year">
            {`2011 to 2015 `}<span>(Discontinued to focus on my project at AWS)</span>
          </p>
          <div className="HeartWriter-buttons">
            <div
              className="HeartWriter-learnMoreBtn"
              onClick={this._onClickLearnMoreBtn}>
              <div className="HeartWriter-heartIcon"/>
              {`Learn More`}
            </div>
            <div 
              className={classnames('HeartWriter-seeReviewsPopover', {
                open: this.state.showPopover
              })}
              ref="popoverNode">
              <div
                className="HeartWriter-seeReviewsBtn"
                onClick={this._onClickSeeReviewsBtn}>
                <div className="HeartWriter-downArrowIcon"/>
                {`See Reviews`}
              </div>
              <ReactCSSTransitionGroup
                transitionName="transition"
                transitionEnterTimeout={400}
                transitionLeaveTimeout={400}>
                {
                  this.state.showPopover &&
                  <div 
                    className="HeartWriter-reviews"
                    key="HeartWriter-reviews">
                    {
                      [
                        { title: '148apps', href: 'http://www.148apps.com/reviews/heart-writer' },
                        { title: 'AppAdvice', href: 'http://appadvice.com/appnn/2011/05/quickadvice-heart-writer' },
                        { title: 'AppBank (Japan)', href: 'http://www.appbank.net/2011/07/12/ipad/271816.php' },
                        { title: 'MacWelt (Germany)', href: 'http://www.macwelt.de/apps/Heart-Writer-3348381.html' }
                      ].map(({ title, href }, idx) => (
                        <div
                          key={idx}
                          className="HeartWriter-reviewLinkWrapper">
                          <a
                            className="HeartWriter-reviewLink"
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer">
                            {title}
                          </a>
                        </div>
                      ))
                    }
                    <a
                      className="HeartWriter-searchMore"
                      href={`https://www.google.com/search?q="heart+writer"+review`}
                      target="_blank"
                      rel="noopener noreferrer">
                      {`Or search ‘Heart Writer’`}<br/>{`on Google for more!`}
                    </a>
                  </div>
                }
              </ReactCSSTransitionGroup>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (ismobilejs.any) {
      return;
    }

    this._videoWrapperNode = this.refs.videoWrapperNode;
    this._videoNode = this.refs.videoNode;
    this._fullWidth = Math.ceil(domHelperHeight(this._videoWrapperNode) * 16 / 9);
    this._player = videojs('HeartWriter-video', {}, () => {});

    this._attachListeners();
  }

  componentWillUnmount() {
    this._detachListeners();
  }

  _attachListeners = () => {
    this._scrollListener = EventListener.listen(window, 'scroll', this._onScrollOrResize);
    this._resizeListener = EventListener.listen(window, 'resize', lodashThrottle(this._onScrollOrResize, 50));
    this._mouseDownListener = EventListener.listen(document, 'mouseup', this._onClickOutside);
    this._touchStartListener = EventListener.listen(document, 'click', this._onClickOutside);

    this._onScrollOrResize();
  };

  _detachListeners = () => {
    if (this._scrollListener) {
      this._scrollListener.remove();
      this._scrollListener = null;
    }
    if (this._resizeListener) {
      this._resizeListener.remove();
      this._resizeListener = null;
    }
    if (this._mouseDownListener) {
      this._mouseDownListener.remove();
      this._mouseDownListener = null;
    }
    if (this._touchStartListener) {
      this._touchStartListener.remove();
      this._touchStartListener = null;
    }
  };

  _onScrollOrResize = () => {
    const windowWidth = domHelperWidth(window);
    const scaleRatio = this._fullWidth > windowWidth ? this._fullWidth / windowWidth : windowWidth / this._fullWidth;
    const transform = `scale3d(${scaleRatio},${scaleRatio},${scaleRatio})`;

    domHelperStyle(this._videoNode, {
      '-webkit-transform': transform,
      '-moz-transform': transform,
      '-ms-transform': transform,
      '-o-transform': transform,
      'transform': transform
    });
  };

  _onClickLearnMoreBtn = () => {
    this.context.openModal(
      (
        <div className="HeartWriter-modal">
          <Gallery
            className="HeartWriter-gallery"
            items={[
              {
                image: image1,
                title: 'Swipe to type',
                description: ''
              },
              {
                image: image2,
                title: 'The first app with an advanced keyboard extension',
                description: 'Since then, some other writer apps have integrated the Heart Writer style keyboard.'
              },
              {
                image: image3,
                title: 'Top 5 in Productivity Paid iPad Apps Chart',
                description: ''
              },
              {
                image: image5,
                title: 'Chosen as one of iPad apps a freelance writer should try!',
                description:
                  <span>
                    {`It was the most exciting news for me. `}
                    <a
                      className="HeartWriter-link"
                      href="http://allindiewriters.com/choosing-a-word-processing-app-for-your-ipad"
                      target="_blank"
                      rel="noopener noreferrer">
                      {`Click here to see the full article.`}
                    </a>
                  </span>
              }
            ]}
            metricsName="HeartWriter"
          />
        </div>
      )
    );
  };

  _onClickOutside = (evt) => {
    if (!this.state.showPopover || domHelperContains(this.refs.popoverNode, evt.target) || evt.target.tagName === 'HTML') {
      return;
    }
    evt.stopPropagation();
    this.setState({
      showPopover: false
    })
  };

  _onClickSeeReviewsBtn = () => {
    this.setState({
      showPopover: !this.state.showPopover
    });
  };

}

export default HeartWriter;



// WEBPACK FOOTER //
// ./src/components/HeartWriter.js